import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { INode } from '../node.interface';
@Component({
  selector: 'ngx-org-chart-designer',
  templateUrl: './chart-designer.component.html',
  styleUrls: ['./chart-designer.component.scss']
})
export class OrgChartDesignerComponent {
  @Input() node: INode;
  @Input() hasParent = false;
  @Input() direction: 'vertical' | 'horizontal' = 'vertical';
  @Input('useBadge') useBadge: boolean = false; // 뱃지 사용여부
  @Input('badgeField') badgeField: string = 'depth'; // 뱃지에 표시된 내용

  @Output() itemClick = new EventEmitter<INode>();

  @HostBinding('style.flex-direction')
  get hostClass() {
    return this.direction === 'vertical' ? 'column' : '';
  }
}
